import * as React from "react";
import {Helmet} from "react-helmet";
import HeroTextOnLeftBlock from "../layouts/hero-text-on-left-block/hero-text-on-left-block";
import TitleBlock from "../layouts/title-block/title-block";
import IntroStepSelectBlock from "../layouts/intro-step-select-block/intro-step-select-block";
import PricingTableBlock from "../layouts/pricing-table-block/pricing-table-block";
import ContactFormBlock from "../layouts/contact-form-block/contact-form-block";
import FaqBlock from "../layouts/faq-block/faq-block";
import { PageType } from "../models/types";
import { GoogleAnalyticsEventType } from "../models/google-analytics";
import * as staticImages from "../constants/static-images";
import * as initialFormData from "../constants/form-data";
import * as freshworksData from "../constants/freshworks-data";
import * as faqQuestionsData from "../constants/faq-questions-data";
import * as helmetData from "../constants/helmet-data";
import * as cacheBustingService from "../services/cache-busting-service";

interface ZakladanieSpolekZooPageProps {}

interface ZakladanieSpolekZooPageState {}

class ZakladanieSpolekZooPage extends React.Component<ZakladanieSpolekZooPageProps,ZakladanieSpolekZooPageState> {

  componentDidMount() {
    cacheBustingService.handleCacheBusting(caches);
  }

  render() {
    return (
      <div>
        <Helmet {...helmetData.prepareHelmetData(PageType.ZakladanieSpolekZooPage)}/>

        <HeroTextOnLeftBlock
          title={"Zakładanie spółek online"}
          description={["Skorzystaj z naszej pomocy."]}
          backgroundImage={staticImages.BUSINESS_HANDSHAKE_BACKGROUND_IMAGE}
          componentViewEventType={GoogleAnalyticsEventType.ZakladanieSpolekZooPageViewedMainTitleBlock}
        />

        <TitleBlock
          firstLineBlackStart={"Własna firma w formie spółki z o.o. w"}
          firstLineBlue={"3 krokach"}
          firstLineBlackEnd={""}
          secondLineText={"Skorzystaj z pomocy profesjonalistów, którzy specjalizują się w prawie handlowym."}
          paddingBottom={0}
        />
        <IntroStepSelectBlock
          stepSelectElements={[
            {
              elementSelectorTitle: "DOSTĘPNE WARIANTY",
              elementSelectorDescription: [
                "Wszystkie usługi przeprowadzania procedury rejestracji realizowane są przez profesjonalnych pełnomocników - adwokatów lub radców prawnych. Można wyróżnić dwie procedury rejestracji sp. z o.o.:",
                "a) online w systemie S24 przy pomocy uproszczonego wzorca Ministerstwa Sprawiedliwości oraz",
                "b) tradycyjnej przed notariuszem przez zawiązanie umowy szytej na miarę - trwałej na lata, gotowej na polski ład, przygotowanej przez profesjonalnego pełnomocnika."
              ]
            },
            {
              elementSelectorTitle: "SKONTAKTUJ SIĘ",
              elementSelectorDescription: "Jeżeli chcesz przystąpić do dalszych działań lub jeżeli masz więcej pytań - skontaktuj się z nami. Uzyskasz informacje na temat dalszych czynności. Kontakt jest możliwy poprzez czat, infolinię oraz umieszczony poniżej formularz kontaktowy."
            },
            {
              elementSelectorTitle: "ZAKŁADANIE SPÓŁKI",
              elementSelectorDescription: "Ostatni etap zakładania spółki polega na przygotowaniu umowy, wniosku rejestracyjnego do KRS oraz pozostałych niezbędnych dokumentów. W każdej chwili mogą Państwo sprawdzić aktualny status sprawy, by dobrze rozplanować działania biznesowe. Po zawiązaniu umowy przed notariuszem lub uzyskaniu wpisu do KRS już nic nie stoi na przeszkodzie, by rozpocząć działalność gospodarczą."
            }
          ]}
          componentViewEventType={GoogleAnalyticsEventType.ZakladanieSpolekZooPageViewedStepSelectBlock}
          elementSelectEventType={GoogleAnalyticsEventType.ZakladanieSpolekZooPageClickedStepSelectElement}
        />

        <TitleBlock
          id={'kontakt'}
          firstLineBlackStart={"Zainteresowany naszą"}
          firstLineBlue={"ofertą"}
          firstLineBlackEnd={"?"}
          secondLineText={"Skontaktuj się w sprawie dalszych czynności."}
          paddingTop={75}
          paddingBottom={0}
        />
        <ContactFormBlock
          formInfo={initialFormData.ZakladanieSpolekZooPageFormInfo}
          iframeSourceUrl={freshworksData.ZAKLADANIE_SPOLEK_PAGE_FORM_IFRAME_SOURCE_URL}
        />

        <TitleBlock
          firstLineBlackStart={"Najczęściej zadawane"}
          firstLineBlue={"pytania"}
          firstLineBlackEnd={""}
          secondLineText={"Zapoznaj się z odpowiedziami na najczęściej zadawane pytania."}
          paddingTop={100}
        />
        <FaqBlock
          faqQuestions={faqQuestionsData.ZAKLADANIE_SPOLEK_PAGE_FAQ_QUESTIONS}
          componentViewEventType={GoogleAnalyticsEventType.ZakladanieSpolekZooViewedFaqBlock}
          faqQuestionReadEventType={GoogleAnalyticsEventType.ZakladanieSpolekZooReadFaqQuestion}
        />

      </div>
    )
  }

}

export default ZakladanieSpolekZooPage


// WEBPACK FOOTER //
// ./src/pages/zakladanie-spolek-zoo.tsx